import type { z } from "zod";

export type NormalizedHistoryFields<Field extends string> = {
  fields: Field[];
  unrecognizedKeys: string[];
};

export const normalizeHistoryFields = <Field extends string>(
  keys: readonly string[],
  schema: z.ZodType<Field>,
  fieldByKey: Readonly<Record<string, Field | null | undefined>>,
): NormalizedHistoryFields<Field> => {
  const fields = new Set<Field>();
  const unrecognizedKeys = new Set<string>();

  for (const key of keys) {
    const current = schema.safeParse(key);
    if (current.success) {
      fields.add(current.data);
      continue;
    }

    const mapped = fieldByKey[key];
    if (mapped !== null && mapped !== undefined) fields.add(mapped);
    else if (mapped === undefined) unrecognizedKeys.add(key);
  }

  return { fields: [...fields], unrecognizedKeys: [...unrecognizedKeys] };
};
